// extracted by mini-css-extract-plugin
export default {"root":"TabletChipStrip_root__UvbmW","chip":"TabletChipStrip_chip__ZEOU1","chipActive":"TabletChipStrip_chipActive__EMoER"};